/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import NumberFormat from 'react-number-format'
import styled from 'styled-components'

export const InputRoot = styled.div<{
  noMargin?: boolean
  fullWidth?: boolean
  height?: number
}>`
  position: relative;
  ${({ fullWidth }) => fullWidth && `width: 100%;`}
  ${({ height }) => height && `height: ${height}px;`}
  ${({ noMargin }) => !noMargin && `margin: 15px 0;`}

  input:disabled {
    background: #f0eff0;
  }
`

export const InputContainer = styled.div<{
  touched: boolean
  disabled: boolean
  fullWidth: boolean
  error: boolean
}>`
  display: flex;
  height: 48px;
  box-sizing: border-box;
  padding-left: 10px;
  border-radius: 8px;
  align-items: center;
  ${({ fullWidth }) => fullWidth && `width: 100%;`}

  background: ${({ theme }) => theme.colors.white} 0% 0% no-repeat padding-box;
  border: 1px solid
    ${({ theme, error }) => (error ? theme.colors.error : theme.colors.border)};

  color: ${({ theme }) => theme.colors.fontMain};
  font-size: 16px;
  letter-spacing: -0.36px;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.colors.fontSecondary};
    text-align: ${({ touched }) => (touched ? 'right' : 'left')};
    opacity: 1;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }


`
export const InputMaskContainer = styled(NumberFormat)<{
  touched: boolean
  disabled: boolean
  fullWidth: boolean
  error: boolean
}>`
  display: flex;
  height: 48px;
  box-sizing: border-box;
  padding-left: 10px;
  border-radius: 8px;
  align-items: center;
  ${({ fullWidth }) => fullWidth && `width: 100%;`}

  background: ${({ theme }) => theme.colors.white} 0% 0% no-repeat padding-box;
  border: 1px solid
    ${({ theme, error }) => (error ? theme.colors.error : theme.colors.border)};

  ${({ theme, disabled }) =>
    disabled &&
    `
    color: ${theme.colors.fontSecondary};
  `}
  color: ${({ theme }) => theme.colors.fontMain};
  font-size: 16px;
  letter-spacing: -0.36px;
  width: 100%;
  ::placeholder {
    color: ${({ theme }) => theme.colors.fontSecondary};
    //text-align: ${({ touched }) => (touched ? 'right' : 'left')};
    opacity: 1;
  }

  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`

export const InputLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -8px;
  box-sizing: border-box;
  padding: 0px 5px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
`
export const InputLabelSpan = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`

export const InputStyled = styled.input<{
  touched: boolean
  disabled: boolean
}>`
  color: ${({ theme }) => theme.colors.fontMain};
  border: none;
  outline: none;
  background: transparent;
  padding-left: 10px;
  font-size: 16px;
  letter-spacing: -0.36px;

  min-width: 80px;
  width: 100%;

  ::placeholder {
    color: ${({ theme }) => theme.colors.fontSecondary};
    opacity: 1;
  }

  ${({ theme, disabled }) =>
    disabled &&
    `
    color: ${theme.colors.fontSecondary};
  `}
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }
`

export const IconStyle = (
  theme: any,
  style?: React.CSSProperties
): React.CSSProperties => ({
  fontSize: 18,
  color: theme.colors.fontSecondary,
  ...style,
})
